import { put, call, takeLatest } from 'redux-saga/effects';
import { actions } from './Reducer';
import {
  // getArtisansSuccessAction,
  setArtisansIsLoadingAction,
  // setArtisansCountAction,
  // deleteArtisanSuccessAction,
  // getArtisanSuccessAction,
  // createArtisanSuccessAction,
  // updateArtisanSuccessAction,
  getFollowersSuccess,
  getFollowersCountSucessAction
  
} from './Actions';
import {
  errorNotificationFromError,
  newSuccessNotificationAction,
} from '../../notifications/Actions';
import * as api from './Api';

import { push } from 'connected-react-router';

// function* createArtisan({ payload }) {
//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     const response = yield call(api.createArtisan, payload);

//     const { data } = response;
//     const artisan = data;
//     yield put(createArtisanSuccessAction(artisan));
//     yield put(newSuccessNotificationAction('Artisan Created'));
//     yield put(push('/artisans'));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

// function* updateArtisan({ payload }) {
//   const { formData, id } = payload;

//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     const response = yield call(api.updateArtisan, id, formData);
//     const { data } = response;
//     console.log(formData);
//     yield put(updateArtisanSuccessAction(data));
//     yield put(newSuccessNotificationAction('Artisan Updated'));
//     yield put(push('/artisans'));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

// function* getArtisan({ payload }) {
//   const artisanId = payload;

//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     const response = yield call(api.getArtisan, artisanId);
//     const { data } = response;
//     const artisan = data;
//     yield put(getArtisanSuccessAction(artisan));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

// function* deleteArtisan({ payload }) {
//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     yield call(api.deleteArtisan, payload);

//     yield put(deleteArtisanSuccessAction(payload));
//     yield put(newSuccessNotificationAction('Artisan Deleted'));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

// //
// function* addFollower({ artisanId, userId }) {
//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     yield call(api.addFollower, artisanId, userId);

//     yield put(newSuccessNotificationAction('Artisan Followed'));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

// function* removeFollwer({ artisanId, userId }) {
//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     yield call(api.removeFollower, artisanId, userId);
//     yield put(newSuccessNotificationAction('Artisan Removed'));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

function* getFollowers({ payload }) {
  const artisanId = payload
  try {
    yield put(setArtisansIsLoadingAction(true));
    const response = yield call(api.getFollowers, artisanId);
    const { data} = response
    const {followers} = data
    yield put(getFollowersSuccess(followers));
  } catch (error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisansIsLoadingAction(false));
  }
}

function* getFollowerCount({payload}) {
  const artisanId = payload
  try {
    yield put(setArtisansIsLoadingAction(true));
    const response = yield call(api.getFollowersCount, artisanId) 
    const { data } = response
  yield put(getFollowersCountSucessAction(data))
  } catch(error) {
    yield put(errorNotificationFromError(error));
  } finally {
    yield put(setArtisansIsLoadingAction(false));
  }
}

// function* getArtisans({ payload }) {
//   const defData = {
//     offset: 0,
//     size: 10,
//     searchTerm: '',
//     filterBy: [],
//     filterCountry: '',
//     sort: 'businessName',
//     dir: 'asc',
//   };

//   const body = { ...defData, ...payload };

//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     const response = yield call(api.getArtisans, body);

//     const { data } = response;
//     console.log(data);
//     const count = data.count;
//     const artisans = data.content;
//     // const count = data.count;
//     // const artisans = data.content
//     yield put(setArtisansCountAction(count));
//     yield put(getArtisansSuccessAction(artisans));
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

// function* addEditorReview({ payload }) {
//   const { artisanId, formData } = payload;
//   try {
//     yield put(setArtisansIsLoadingAction(true));
//     const response = yield call(api.addEditorsReview, artisanId, formData);
//     const { data } = response;
//     yield put(updateArtisanSuccessAction(data));
//     yield put(newSuccessNotificationAction('Thanks for Your Review'))
//   } catch (error) {
//     yield put(errorNotificationFromError(error));
//   } finally {
//     yield put(setArtisansIsLoadingAction(false));
//   }
// }

export default function*() {
  // yield takeLatest(actions.UPDATE_ARTISAN, updateArtisan);
  // yield takeLatest(actions.CREATE_ARTISAN, createArtisan);
  // yield takeLatest(actions.GET_ARTISAN, getArtisan);
  // yield takeLatest(actions.DELETE_ARTISAN, deleteArtisan);
  // yield takeLatest(actions.ADD_EDITOR_REVIEW_ARTISAN, addEditorReview);
  // yield takeLatest(actions.GET_ARTISANS, getArtisans);
  yield takeLatest(actions.GET_ARTISAN_FOLLOWRS,getFollowers)
  yield takeLatest(actions.GET_ARTISAN_FOLLOWRS_COUNT,getFollowerCount) 
}